// Shared by the live API, demo reports and offline adjusted workbooks.
// Operating costs are an eligible allowance based on client funding, not spend.
function currencyCents(value) {
  const amount = Number(value);
  return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
}

function buildRegionalSnapshotDerivedValues(snapshot, liveMetrics, fundingMetrics) {
  const totalFundingCents = currencyCents(fundingMetrics?.crfFundingAmount) +
    currencyCents(fundingMetrics?.eiFundingAmount);
  const operatingCostsCents = Math.round(totalFundingCents * 15 / 100);
  const totalFunding = totalFundingCents / 100;
  const fundingClientCount = Number(fundingMetrics?.fundedClientCount);
  const fundedCount = Number.isFinite(fundingClientCount)
    ? fundingClientCount
    : Number(liveMetrics?.fundedClients || 0);
  return {
    totalFunding,
    operatingCostsAmount: operatingCostsCents / 100,
    totalAdminCost: (currencyCents(snapshot?.coordinatorSalaryAmount) + operatingCostsCents) / 100,
    clientAverageAmountFunded: fundedCount > 0 ? totalFunding / fundedCount : null,
  };
}

module.exports = { buildRegionalSnapshotDerivedValues };
